import { useQuery } from '@tanstack/react-query';
import { scanApi } from '@/services/api';

export function useRadarRegistrars(refreshMs = 60_000) {
  return useQuery({
    queryKey: ['radar-registrars'],
    queryFn: () => scanApi.getRadarRegistrars(),
    refetchInterval: refreshMs,
    staleTime: refreshMs,
  });
}

export function useRadarServices(refreshMs = 5 * 60_000) {
  return useQuery({
    queryKey: ['radar-services'],
    queryFn: () => scanApi.getRadarServices(),
    refetchInterval: refreshMs,
    staleTime: refreshMs,
  });
}

export function useRadarNews(limit = 30) {
  return useQuery({
    queryKey: ['radar-news', limit],
    queryFn: () => scanApi.getRadarNews(limit),
    staleTime: 5 * 60_000,
  });
}
